// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/list","root":"list-m__root__3ee5s","menu":"list-m__menu___jE2c","divider":"list-m__divider__2pf5q"};